module.exports = __webpack_public_path__ + "img/book(6).b0b056bb.png";